import {Injectable} from "@angular/core";
import {ConfProxy} from "../../http/services/conf.proxy";
import {HttpObservable} from "../../http/services/http.wrapper";
import {ISystemConfiguration} from "../interfaces/interfaces";

/**
 ****************************************************************
 * Proxy class for getting system configuration from server.
 *
 * Written by: Stanislav Korobov
 ****************************************************************
 */
@Injectable({ providedIn: 'root' })
  export class SystemConfigurationProxy {
	constructor(private confHttp:ConfProxy) {
	}

	public GetPreLoginSystemConfiguration():HttpObservable<ISystemConfiguration> {
		return this.confHttp.getAnon("ConfigurationAnon", "GetPreLoginSystemConfiguration", null, null);
	}

	public GetSystemConfiguration():HttpObservable<ISystemConfiguration> {
		return this.confHttp.get("Configuration", "GetSystemConfiguration", null, null);
	}
}
